export function requestFullscreen(element: any) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

export function exitFullscreen() {
  const doc: any = document;

  if (doc.exitFullscreen) {
    doc.exitFullscreen();
  } else if (doc.msExitFullscreen) {
    doc.msExitFullscreen();
  } else if (doc.mozCancelFullScreen) {
    doc.mozCancelFullScreen();
  } else if (doc.webkitExitFullscreen) {
    doc.webkitExitFullscreen();
  }
}

export function getFullscreenElement() {
  const doc: any = document;

  if (doc.fullscreenElement) {
    return doc.fullscreenElement;
  } else if (doc.mozFullScreenElement) {
    return doc.mozFullScreenElement;
  } else if (doc.webkitFullscreenElement) {
    return doc.webkitFullscreenElement;
  } else if (doc.msFullscreenElement) {
    return doc.msFullscreenElement;
  }

  return null;
}

export function repaintPage() {
  document.body.style.display = 'none';
  document.body.offsetHeight; // eslint-disable-line
  document.body.style.display = 'block';
}

document.addEventListener('fullscreenchange', () => {
  const fullscreenElement = getFullscreenElement();

  if (fullscreenElement) {
    console.log(`Element: ${fullscreenElement.id} entered full-screen mode.`);
  } else {
    console.log('Leaving full-screen mode.');
    repaintPage();
  }
});
